/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import { handleBlobResponse } from '../../../../client/js/lib/download'
import rest from '../../../../client/js/lib/rest'

export function deleteInvoiceTemplateById (id: string) {
  return rest.delete(`/api/invoices/templates/${id}/file`)
}

export function downloadInvoiceTemplateById (id: string) {
  return rest.get(`/api/invoices/templates/${id}/file`)
    .then(handleBlobResponse)
}

export function fetchInvoiceTemplateById (id: string): Promise<S3TemplateMeta> {
  return rest.get(`/api/invoices/templates/${id}`)
    .then((resp) => resp.json())
}

export function uploadInvoiceTemplate (id: string, file: File) {
  const fd = new FormData()
  fd.append('file', file)
  return rest.put(`/api/invoices/templates/${id}/file`, { body: fd })
    .then((resp) => resp.json())
}
